import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import "./Blogs.css";
import { API_URL } from "../../utils/Url";
import axios from "axios";
import { toast } from "react-toastify";

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  /* Pagination */
  // const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // Bumped to 10 for a standard premium listing grid
  const currentPage = Number(searchParams.get("page")) || 1;
  const handlePageChange = (newPage) => {
    setSearchParams((prevParams) => {
      prevParams.set("page", newPage);
      return prevParams;
    });
  };
  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${API_URL}/api/blog/get_blogs`);
      if (data) {
        setBlogs(data?.blogs || []);
        setLoading(false);
      }
    } catch (error) {
      console.error(error, "fetching blogs error");
      toast.error("Failed to sync content engine registry");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  /* 🔍 Dynamic Client-Side Search Search */
  useEffect(() => {
    const filtered = blogs.filter((b) =>
      b.title?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    setFilteredBlogs(filtered);
    handlePageChange(1);
  }, [searchQuery, blogs]);

  /* Pagination logic */
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredBlogs.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(filteredBlogs.length / recordsPerPage);

  /* Actions - Handlers match your exact core state transitions */
  const handleDelete = async (slug) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized operation sequence");
      return;
    }

    if (
      !window.confirm(
        "Are you absolutely sure you want to remove this publication?",
      )
    )
      return;

    const previousBlogs = blogs;
    setBlogs((prev) => prev.filter((b) => b.slug !== slug));

    try {
      await axios.delete(`${API_URL}/api/blog/delete_blog/${slug}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Article safely deleted 🗑️");
    } catch (error) {
      setBlogs(previousBlogs);
      toast.error(
        error.response?.data?.message || "Failed to drop context schema record",
      );
    }
  };

  const handleStatusToggle = async (slug) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Session verification required");
      return;
    }

    setBlogs((prev) =>
      prev.map((b) =>
        b.slug === slug
          ? { ...b, status: b.status === "active" ? "inactive" : "active" }
          : b,
      ),
    );

    try {
      await axios.put(
        `${API_URL}/api/blog/status_blog/${slug}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success("Visibility rules updated");
    } catch (error) {
      setBlogs((prev) =>
        prev.map((b) =>
          b.slug === slug
            ? { ...b, status: b.status === "active" ? "inactive" : "active" }
            : b,
        ),
      );
      toast.error(
        error.response?.data?.message || "State toggle dropped mid-flight",
      );
    }
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div
        className="mt-5 main-content px-3 px-md-4 py-4"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* PREMIUM CONTROL HEADER BOARD */}
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mb-4 p-3 bg-white border rounded-4 shadow-sm">
          <div>
            <h2 className="fw-bold text-gray-800 mb-0 fs-3">
              Content Engine Manager
            </h2>
            <p className="text-muted small mb-0">
              Publish, maintain, and stage resource documentation and updates
            </p>
          </div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <div className="bg-light px-3 py-2 rounded-3 border">
              <span className="text-muted small fw-medium me-1">
                Total Articles:
              </span>
              <span className="fw-bold text-dark">{filteredBlogs.length}</span>
            </div>
            <Link
              to="/create-blog"
              className="btn btn-primary rounded-3 fw-semibold px-3 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
            >
              <i className="bi bi-journal-plus fs-5 line-height-0"></i> Add New
              Post
            </Link>
          </div>
        </div>

        {/* SEARCH ACTION CARD */}
        <div className="card border-0 rounded-4 shadow-sm mb-4">
          <div className="card-body p-3">
            <div className="input-group">
              <span className="input-group-text bg-light border-light-subtle text-muted">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control rounded-end-3 border-light-subtle bg-light-subtle py-2"
                placeholder="Search indexed articles by exact string or title match..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* DATA DIRECTORY LAYER */}
        <div className="card border-0 rounded-4 shadow-sm overflow-hidden">
          <div className="card-body p-0">
            {loading ? (
              <div className="d-flex flex-column align-items-center justify-content-center py-5">
                <div
                  className="spinner-border text-primary mb-3"
                  role="status"
                ></div>
                <span className="text-muted small fw-medium">
                  Syncing active database partitions...
                </span>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 custom-admin-table">
                  <thead className="bg-light border-bottom">
                    <tr>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold px-4 py-3"
                        style={{ width: "60px" }}
                      >
                        #
                      </th>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold py-3"
                        style={{ width: "100px" }}
                      >
                        Cover
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Article Title
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Timestamp
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Visibility State
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold px-4 py-3 text-end">
                        Controls
                      </th>
                    </tr>
                  </thead>

                  <tbody className="border-0">
                    {currentRecords.length > 0 ? (
                      currentRecords.map((b, index) => (
                        <tr
                          key={b._id || b.slug}
                          className="align-middle transition-all"
                        >
                          <td className="px-4 fw-semibold text-muted">
                            {firstIndex + index + 1}
                          </td>
                          <td>
                            <div
                              className="position-relative rounded-3 overflow-hidden border bg-light shadow-xs"
                              style={{ width: "90px", height: "56px" }}
                            >
                              <img
                                src={
                                  b?.blogImage?.url ||
                                  "https://images.unsplash.com/photo-1546074177-ffebd9a8b596?q=80&w=200&auto=format&fit=crop"
                                }
                                alt=""
                                className="w-100 h-100 object-cover"
                                onError={(e) => {
                                  e.target.src =
                                    "https://images.unsplash.com/photo-1546074177-ffebd9a8b596?q=80&w=200&auto=format&fit=crop";
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <span
                              className="fw-bold text-dark text-truncate d-inline-block max-w-md-300"
                              style={{ fontSize: "14.5px" }}
                            >
                              {b.title || "Untitled Meta Draft"}
                            </span>
                          </td>
                          <td className="text-muted fs-7">
                            {b.postedOn
                              ? new Date(b.postedOn).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>
                          <td>
                            <button
                              onClick={() => handleStatusToggle(b.slug)}
                              className={`btn btn-sm px-3 rounded-pill fw-bold border text-capitalize fs-7 transition-all ${
                                b.status === "active"
                                  ? "bg-success-subtle text-success border-success-subtle"
                                  : "bg-secondary-subtle text-secondary border-secondary-subtle"
                              }`}
                              style={{ cursor: "pointer" }}
                              title="Click to toggle publication status"
                            >
                              <span
                                className="d-inline-block rounded-circle me-1.5"
                                style={{
                                  width: "6px",
                                  height: "6px",
                                  backgroundColor:
                                    b.status === "active"
                                      ? "#137333"
                                      : "#5f6368",
                                }}
                              ></span>
                              {b.status}
                            </button>
                          </td>
                          <td className="px-4 text-end">
                            <div className="d-flex justify-content-end gap-2">
                              <Link
                                to={`/update/blog/${b.slug}`}
                                className="btn btn-sm btn-light border fw-semibold text-secondary d-inline-flex align-items-center gap-1 shadow-xs px-2.5"
                              >
                                <i className="bi bi-pencil-square"></i> Edit
                              </Link>
                              <button
                                onClick={() => handleDelete(b.slug)}
                                className="btn btn-sm btn-outline-danger fw-medium d-inline-flex align-items-center gap-1 px-2.5"
                              >
                                <i className="bi bi-trash3"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-5">
                          <div className="text-muted d-flex flex-column align-items-center justify-content-center gap-2">
                            <i className="bi bi-journal-x fs-1 text-gray-300"></i>
                            <p className="mb-0 fw-semibold text-dark fs-5">
                              No catalog records found
                            </p>
                            <p className="mb-0 text-muted small">
                              Try modifying your query text parameters.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* INTERACTIVE COMPACT PAGINATION FOOTER */}
            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center p-4 border-top bg-light-subtle">
                <div className="text-muted small">
                  Showing entries{" "}
                  <span className="fw-semibold text-dark">
                    {filteredBlogs.length > 0 ? firstIndex + 1 : 0}
                  </span>{" "}
                  to{" "}
                  <span className="fw-semibold text-dark">
                    {lastIndex > filteredBlogs.length
                      ? filteredBlogs.length
                      : lastIndex}
                  </span>{" "}
                  of{" "}
                  <span className="fw-semibold text-dark">
                    {filteredBlogs.length}
                  </span>{" "}
                  records
                </div>
                <nav aria-label="Blog pagination navigation">
                  <ul className="pagination pagination-sm mb-0 gap-1">
                    {/* First Page Button */}
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3"
                        onClick={() => handlePageChange(1)}
                      >
                        First
                      </button>
                    </li>

                    {/* Page Number Buttons */}
                    {Array.from({ length: totalPages }).map((_, i) => (
                      <li
                        key={i}
                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                      >
                        <button
                          onClick={() => handlePageChange(i + 1)}
                          className="page-link rounded-2 border fw-semibold px-3"
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}

                    {/* Last Page Button */}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3"
                        onClick={() => handlePageChange(totalPages)}
                      >
                        Last
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllBlogs;
